// extracted by mini-css-extract-plugin
export default {"button":"EMtV3","downloadIcon":"xjf0F"};